import { Loader } from '@driftt/tide-core'
import { Subnav } from '@driftt/tide-subnav'
import React, { lazy, Suspense, useEffect, useState } from 'react'
import { NavLink, Redirect, Route, Switch } from 'react-router-dom'

import config from 'config/index'
import {
  userHasAnyPlaybookAccess,
  userHasSearchAppExperience,
} from 'utils/access'
import { getSubNavNodes } from 'utils/getSubNavNodes'

const IframeWrapper = lazy(() => import('./IframeWrapper'))

export default function SiteConcierge() {
  const hasAnyPlaybookAccess = userHasAnyPlaybookAccess()
  const hasSiteConciergeSearchApp = userHasSearchAppExperience()

  const [sidebarIsOpen, setSidebarIsOpen] = useState(false)

  const SUB_NAV_NODES = getSubNavNodes()

  const handleIframeMessage = (
    event: MessageEvent<{
      name: 'DRIFT_WIDGET'
      action: string
      data?: unknown
    }>
  ) => {
    const eventData = event.data

    if (
      eventData.name !== 'DRIFT_WIDGET' ||
      event.origin !== config.EXPERIENCES_WEB_URL
    ) {
      return
    }

    switch (eventData.action) {
      case 'hide':
        window.drift?.hide()
        break
      case 'show':
        window.drift?.show()
        break
      default:
        break
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleIframeMessage)
    return () => {
      window.removeEventListener('message', handleIframeMessage)
    }
  }, [])

  /*
  This section is born as a replacement for SC, which will be paused and only Search is kept now with the name Intelligent Search
  */

  return (
    <>
      {hasAnyPlaybookAccess && (
        <Subnav
          open={sidebarIsOpen}
          title="Playbooks"
          nodes={SUB_NAV_NODES}
          NavLink={NavLink}
          onToggle={() => setSidebarIsOpen(!sidebarIsOpen)}
        />
      )}
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route
            exact
            path="/intelligent-search/appearance"
            render={() => <IframeWrapper path="appearance" show />}
          />
          <Route
            exact
            path="/intelligent-search/search"
            render={() => (
              <IframeWrapper path="search" show={hasSiteConciergeSearchApp} />
            )}
          />
          <Route render={() => <Redirect to="/playbooks" />} />
        </Switch>
      </Suspense>
    </>
  )
}
